import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";

export class ZIDXSavedSearch implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxSavedSearchesContainer";
    }
    render(){
        // console.log("saved search");
    }
}